import tlmsMap from "./map/tlms_map";
import {activate, addSelectorActivation} from './droom/activate';
import {log, startLogging} from "./droom/logging";
import fadeFlashes from "./tlms/flashes";
import masthead from "./tlms/masthead";
import searchForm from "./tlms/search";

function livemap(el) {
  console.log('💡 livemap', el);
  if (el) {
    const map = tlmsMap(el);
    console.log('map', map);
    document.querySelectorAll('a[data-map-feature]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        map.gotoFeature(el.dataset.mapFeature);
      })
    });
  }
}

console.log('💡mappin');
addSelectorActivation('masthead', '#tlms_nav', masthead);
addSelectorActivation('search', '.search_holder', searchForm);
addSelectorActivation('livemap', '#mbmap', livemap);

document.addEventListener('DOMContentLoaded', (_) => {
  startLogging(); // unless production...
  log('✅ map DOMContentLoaded');
  activate(document);
  fadeFlashes();
});
